function closeBigSlider() {
	const overlayNews = document.querySelector('.news__overlay')
	const newsSliderBig = document.querySelector('.news-slider--big')
	const wrapperBig = document.querySelector('.swiper-wrapper--big')

	overlayNews.addEventListener('click', e => {
		try {
			wrapperBig.style.display = 'none'
			newsSliderBig.style.display = 'none'
			overlayNews.style.display = 'none'
		} catch (err) { }
		})
}
